import { buildIncludesString } from '../utilities/utilityFunctions';
import { hearingIncludes } from './includes';
import { Pages } from './pages';

export const defaultPageIncludes = {
  [Pages.CurrentHearingsPage]: {
    hearing: buildIncludesString(
      hearingIncludes.contents,
      hearingIncludes.contentTypes,
    ),
  },
  [Pages.MyHearingsPageWritten]: {
    hearing: buildIncludesString(
      hearingIncludes.contents,
      hearingIncludes.contentTypes,
    ),
  },
  [Pages.MyHearingsPageResponded]: {
    hearing: buildIncludesString(
      hearingIncludes.contents,
      hearingIncludes.contentTypes,
    ),
  },
  [Pages.MyHearingsPageInvited]: {
    hearing: buildIncludesString(
      hearingIncludes.contents,
      hearingIncludes.contentTypes,
    ),
  },
  [Pages.MyHearingsPageReviewed]: {
    hearing: buildIncludesString(
      hearingIncludes.contents,
      hearingIncludes.contentTypes,
    ),
  },
  [Pages.ConcludedHearingsPage]: {
    hearing: buildIncludesString(
      hearingIncludes.contents,
      hearingIncludes.contentTypes,
    ),
  },
  [Pages.AdministrationPage]: {
    hearing: buildIncludesString(
      hearingIncludes.contents,
      hearingIncludes.contentTypes,
      hearingIncludes.userHearingRoles,
    ),
  },
};
